export default defineNuxtPlugin((nuxtApp) => {
  // Server-side logic
  if (process.server) {
    const event = useRequestEvent()
    const headers = useRequestHeaders()

    if (event) {
      event.node.res.setHeader('Vary', 'x-ua-device') // Ensure proper caching based on device type
    }

    const uaDevice = headers['x-ua-device']
    const isDesktop = uaDevice
      ? uaDevice === 'desktop'
      : !headers['user-agent']?.includes('Mobile')

    // Provide the isDesktop value for server-side rendering
    nuxtApp.provide('isDesktop', isDesktop)

    // Set a global script tag to pass the value to the client-side
    useHead({
      script: [
        {
          innerHTML: `window.isDesktop = ${isDesktop};`,
          type: 'text/javascript',
        },
      ],
    })
  }

  // Client-side logic
  if (process.client) {
    // Retrieve isDesktop from window or determine based on userAgent if not present
    const isDesktop =
      window.isDesktop || !navigator.userAgent.includes('Mobile')

    // Provide the isDesktop value for client-side usage
    nuxtApp.provide('isDesktop', isDesktop)
  }
})
